import React from 'react';
import PropTypes from 'prop-types';
import PageListDescendantPages from '../../containers/PageListDescendantPages';

const DEFAULT_SAVE_BODY = 'Are you sure you want to save and continue?';

const propTypes = {
  onLoad: PropTypes.func.isRequired,
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const ConfirmBreadcrumbSave = ({ onLoad, page }) => (
  <PageListDescendantPages
    ids={[page.id]}
    message={DEFAULT_SAVE_BODY}
    onLoad={onLoad}
  />
);

ConfirmBreadcrumbSave.propTypes = propTypes;
ConfirmBreadcrumbSave.defaultProps = defaultProps;

export default ConfirmBreadcrumbSave;
